import type { ConversationMetadata } from "@mirage/service-conversation/types";
import { ANSWERS_CLIENT_SCENARIOS } from "@mirage/service-conversation/types";

/**
 * Filters out conversations that were created on the SERP page by default
 * but have not had user interactions
 * @param conversation
 */
export const isAutoGeneratedConversation = (
  conversation: ConversationMetadata,
) => {
  return (
    conversation.clientContext &&
    !!ANSWERS_CLIENT_SCENARIOS.find(
      (scenario) => scenario === conversation.clientContext?.clientScenario,
    )
  );
};
